<template>
  <div>
    <div>
      <div class="progress-bar-container">
        <div
          class="bar-style progress"
          style="border-radius: 15px"
        >
          <div
            role="progressbar"
            aria-valuemin="0"
            aria-valuemax="100"
            :style="{
              width: `${percentage}%`,
              'background-color': percentage && color,
            }"
          />
        </div>
        <div
          class="bar-style d-flex justify-content-center text-white"
          style="z-index: 2"
        >
          <div class="m-auto">
            {{ label }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    percentage: Number,
    color: String,
    label: String,
  },
};
</script>

<style lang="scss" scoped>
.bar-style {
  width: 100%;
  height: 100%;
  position: absolute;
  font-size: 0.656rem;
}

.progress-bar-container {
  height: 20px;
  position: relative;
}

.progress {
  background-color: lightgrey;
}
</style>
